module.exports = __webpack_public_path__ + "static/img/vuejs.dff57ae.png";